import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddCompanyForm from "./AddCompanyForm";

const EditUserModal = ({isOpen, onConfirm, onCancel}) => {
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>Edit Company</ModalHeader>
        <ModalBody>
          <AddCompanyForm comingFrom="edit" />
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>Cancel</Button>
          <Button color="primary" onClick={onConfirm}>Save</Button>
        </ModalFooter>
      </Modal>
    )
};

export default EditUserModal;
